import signedFetch from '../util/signedFetch.js';

/**
 * This archives a given list of organisations. The UI only supplies one though.
 * Body consists of:
 *  - orgs: Array of numbers - Required. Org ID(s) to archive
 *  - notifyLearners: Boolean - Optional. Flag to notify students within organisation(s)
 */
export default body => signedFetch('orgArchive', `${__API_BASE__}/org/archive`, 'POST', body);
